import React, { HTMLAttributes } from 'react'

import {
  useToggleNotification,
  UseToggleNotificationReturnType,
} from './use-toggle-notification'
import { NotificationFullButton } from './full-button'
import { NotificationIconButton } from './icon-button'
import { NotificationImageButton } from './image-button'
import { VariantProps } from 'class-variance-authority'
import { buttonVariants } from '@/components/ui/button'

export interface NotificationButtonProps
  extends HTMLAttributes<HTMLButtonElement> {
  id: string
  price: number
  priceLowest: number
  notifiedStatus: UseToggleNotificationReturnType['notifiedStatus']
  onClickNotificationButton: UseToggleNotificationReturnType['onClickNotificationButton']
}
function withNotificationLogic<NotificationButtonProps>(
  Component: React.ComponentType<NotificationButtonProps>,
) {
  // eslint-disable-next-line react/display-name
  return React.forwardRef<
    HTMLAttributes<HTMLButtonElement>,
    { id: string; price: number; priceLowest: number } & {
      alarmBellSize?: number
      buttonVariant?: VariantProps<typeof buttonVariants>['variant']
    }
  >((props, ref) => {
    const { id, price, priceLowest, ...componentProps } = props
    const { notifiedStatus, onClickNotificationButton } = useToggleNotification(
      { id, price, priceLowest },
    )

    return (
      <Component
        {...(componentProps as NotificationButtonProps)}
        ref={ref}
        notifiedStatus={notifiedStatus}
        onClickNotificationButton={onClickNotificationButton}
      />
    )
  })
}
export const NotificationButton = {
  Full: withNotificationLogic(NotificationFullButton),
  Icon: withNotificationLogic(NotificationIconButton),
  Image: withNotificationLogic(NotificationImageButton),
}
